import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { HotelProvider } from "@/context/HotelContext";
import Layout, { NAV } from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Turni from "@/pages/Turni";
import Tickets from "@/pages/Tickets";
import Giornale from "@/pages/Giornale";
import Incidenti from "@/pages/Incidenti";
import Ronde from "@/pages/Ronde";
import Registri from "@/pages/Registri";
import Qualita from "@/pages/Qualita";
import Personale from "@/pages/Personale";
import Report from "@/pages/Report";
import Utenti from "@/pages/Utenti";

const PAGES = { dashboard: Dashboard, turni: Turni, ticket: Tickets, giornale: Giornale, incidenti: Incidenti, ronde: Ronde,
  registri: Registri, qualita: Qualita, personale: Personale, report: Report, utenti: Utenti };

const Protected = () => {
  const { user } = useAuth();
  if (user === null) return <div className="h-screen grid place-items-center text-slate-500 font-mono text-sm">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <HotelProvider><Layout /></HotelProvider>;
};

const Guard = ({ item }) => {
  const { user } = useAuth();
  const Page = PAGES[item.id];
  return item.roles.includes(user.role) ? <Page /> : <Navigate to="/" replace />;
};

const LoginRoute = () => {
  const { user } = useAuth();
  return user ? <Navigate to="/" replace /> : <Login />;
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route element={<Protected />}>
            {NAV.map((n) => <Route key={n.id} path={n.to} element={<Guard item={n} />} />)}
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" theme="light" />
    </AuthProvider>
  );
}
